import Http from './http';
import { API_SERVER, ACCESS_TOKEN_KEY } from '../contants';
import { hadSessionToken, signalSessionExpired } from '../utils/session';

export const uploadPortfolio = async (file: File) => {
  const formData = new FormData();
  formData.append('file', file);

  const accessToken = localStorage.getItem(ACCESS_TOKEN_KEY);
  
  return fetch(`${API_SERVER}/portfolio-upload/upload`, {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
    body: formData,
  })
    .then(async (res) => {
      // Raw fetch (multipart), so it has to report an expired login itself — see http.ts
      if (res.status === 401 && hadSessionToken(accessToken)) signalSessionExpired();
      const data = await res.json();
      if (!res.ok) {
        throw { msg: data.error || 'Failed to upload portfolio data' };
      }
      return data;
    });
};

export const getPortfolioUploads = async (userId?: string) => {
  return Http.get('/portfolio-upload', userId ? { userId } : {});
};

export const getPortfolioUpload = async (id: string) => {
  return Http.get(`/portfolio-upload/${id}`);
};

export const deletePortfolioUpload = async (id: string) => {
  return Http.delete(`/portfolio-upload/${id}`);
};

export const updatePortfolioUpload = async (id: string, updates: { data?: any; fileName?: string; fileSize?: number }) => {
  return Http.put(`/portfolio-upload/${id}`, updates);
};
